import { render, staticRenderFns } from "./BookingList.vue?vue&type=template&id=c20dcf20"
import script from "./BookingList.vue?vue&type=script&lang=js"
export * from "./BookingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports